<template>
  <v-dialog v-model="dialog" persistent max-width="450" class="rounded-xl">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text dark icon color="primary" v-bind="attrs" v-on="on">
        <v-icon color="white">mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card v-if="editRow" class="rounded-xl">
      <v-card-title class="text-h5"> Edit Time </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" v-if="editRow.clockInTime">
            <div>Clock In</div>
            <DateTimeTextField
              v-model="editRow.clockInTime"
              :initDate="editRow.clockInTime"
            />
          </v-col>
          <v-col v-else>
            <div>Clock In</div>
            <v-btn color="green">Set Clock In Time</v-btn>
          </v-col>
          <v-col cols="12" v-if="editRow.clockOutTime">
            <div>Clock Out</div>
            <DateTimeTextField
              :min="editRow.clockInTime"
              v-model="editRow.clockOutTime"
              :initDate="editRow.clockOutTime"
            />
          </v-col>
          <v-col v-else>
            <div>Clock Out</div>
            <v-btn color="red" dark @click="setClockOutTime"
              >Set Clock Out Time</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="dialog = false"> Close </v-btn>
        <v-btn color="green darken-1" text @click="submit" :loading="loading">
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service";
import DateTimeTextField from "@/components/DateTimeTextField.vue";

export default {
  props: ["editRow"],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  components: {
    DateTimeTextField,
  },
  methods: {
    setClockOutTime() {
      this.editRow.clockOutTime = this.$moment();
    },
    submit() {
      console.log("edit press", this.editRow);
      this.loading = true;
      let id = this.editRow.id;
      console.log("id", id, this.editRow);
      if (this.editRow.clockOutTime) {
        this.editRow.status = "clockedOut";
      }
      // delete this.editRow.id;
      timeClockService
        .update(id, this.editRow)
        .then(() => {
          this.dialog = false;
          this.$emit("submit");
          // this.snackbar.text = "Time entry updated";
          // this.snackbar.status = true;
          // this.snackbar.color = "black";
          this.loading = false;
        })
        .catch((err) => {
          this.$emit("error");
          // this.snackbar.text = "Can't save entry, check date and time";
          // this.snackbar.status = true;
          // this.snackbar.color = "error";
          this.loading = false;
          console.log("err :: ", err);
        });
    },
  },
};
</script>

<style scoped>
</style>